import React, { useEffect, useState, useContext } from 'react';
import { getTernaryValue, isMobileDevice } from 'common/utilities/utils';
import AddressStoresContainer from './AddressesAndStores/AddressStoresContainer';
import { UserOrderContext } from 'context/context';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { ClearCartModule } from 'organisms/ClearCartModule/Container/ClearCartComponent';
import AccountHeaderContainer from './AccountHeaderContainer';
import {
  GO_TO_ORDER_HISTORY,
  LOCAL_STORAGE_KEYS,
  IMAGE_SIZE_CONSTANTS,
  RESIZE,
  ROUTE_URL,
} from 'common/constants/SharedConstants';
import OrderHistory from 'organisms/orderHistory/container/orderHistory';
import MessagePage from 'organisms/MessagePage/messagePage';
import FavOrdersContainer from './FavoriteOrders/FavOrdersContainer';
import { showHideBanner } from 'organisms/AccountPage/AU/accountPageUtils';
import AccountSettingsContainer from './AccountSettings/AccountSettingsContainer';
import MyPaymentMethodsContainer from 'organisms/MyPaymentMethods/Container/MyPaymentMethodsContainer';

const AccountComponent = ({ history, setShowKfcHeader }) => {
  const { ADDRESS, FAVORITE_ORDERS, ACCOUNT_SETTING, MESSAGE_TAG, MY_PAYMENT_METHODS } = TRANSLATE_MAPPING_KEY;
  const { FAV_ORDER_ITEM } = IMAGE_SIZE_CONSTANTS;
  const { ITEM_IMAGE_HEIGHT_MOBILE, ITEM_IMAGE_WIDTH_MOBILE, ITEM_IMAGE_HEIGHT_DESKTOP, ITEM_IMAGE_WIDTH_DESKTOP } =
    FAV_ORDER_ITEM;
  const [isMobile, setMobileHeader] = useState(isMobileDevice(window.innerWidth));
  const [currentMenuName, setMenuName] = useState(getTernaryValue(isMobile, '', MESSAGE_TAG));
  const [imageContainerSize, setImageContainerSize] = useState({ width: 0, height: 0 });
  const { userOrderState } = useContext(UserOrderContext);

  const windowResize = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setMobileHeader(isMobileView);
    const size = isMobileView
      ? { height: ITEM_IMAGE_HEIGHT_MOBILE, width: ITEM_IMAGE_WIDTH_MOBILE }
      : {
          height: ITEM_IMAGE_HEIGHT_DESKTOP,
          width: ITEM_IMAGE_WIDTH_DESKTOP,
        };
    setImageContainerSize(size);
  };
  useEffect(() => {
    if (history?.location?.hash?.includes(ROUTE_URL.ACCOUNT_SETTINGS)) {
      setMenuName(ACCOUNT_SETTING);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]);

  useEffect(() => {
    (history?.location?.hash?.includes?.(FAVORITE_ORDERS)) && setMenuName(FAVORITE_ORDERS);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]);

  useEffect(() => {
    history?.location?.selectOption && setMenuName(history?.location?.selectOption);
  }, [history?.location?.selectOption]);

  useEffect(() => {
    window.addEventListener(RESIZE, windowResize);
    showHideBanner(isMobile);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile]);

  useEffect(() => {
    showHideBanner(isMobile);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentMenuName]);

  useEffect(() => {
    windowResize();
    const localdata = localStorage.getItem(LOCAL_STORAGE_KEYS.LOAD_MORE_ORDER_HISTORY);
    if (
      localdata === GO_TO_ORDER_HISTORY ||
      history.location.isNavigatingFromReorder === true ||
      history.location.selectedMenu === GO_TO_ORDER_HISTORY
    ) {
      setMenuName(ROUTE_URL.ORDER_HISTORY);
    }
    return () => {
      localStorage.removeItem(LOCAL_STORAGE_KEYS.LOAD_MORE_ORDER_HISTORY);
      showHideBanner(isMobile);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderSwitch = param => {
    switch (param) {
      case MESSAGE_TAG:
        setShowKfcHeader(false);
        return <MessagePage history={history} isMobile={isMobile} updateMenu={data => setMenuName(data)} />;
      case ACCOUNT_SETTING:
        setShowKfcHeader(false);
        return <AccountSettingsContainer updateMenu={data => setMenuName(data)} isMobile={isMobile} />;
      case ADDRESS:
        return <AddressStoresContainer history={history} isMobile={isMobile} updateMenu={data => setMenuName(data)} />;
      case ROUTE_URL.ORDER_HISTORY:
        setShowKfcHeader(false);
        return <OrderHistory history={history} isMobile={isMobile} updateMenu={data => setMenuName(data)} />;
      case MY_PAYMENT_METHODS:
        setShowKfcHeader(false);
        return (
          <MyPaymentMethodsContainer history={history} isMobile={isMobile} updateMenu={data => setMenuName(data)} />
        );
      case FAVORITE_ORDERS:
        setShowKfcHeader(false);
        return (
          <FavOrdersContainer
            isMobile={isMobile}
            renderSwitch={renderSwitch}
            updateMenu={data => setMenuName(data)}
            imageContainerSize={imageContainerSize}
          />
        );
      default:
        setShowKfcHeader(true);
        return isMobile ? (
          <AccountHeaderContainer
            isMobile={isMobile}
            currentMenu={currentMenuName}
            updateMenu={data => setMenuName(data)}
            history={history}
          />
        ) : null;
    }
  };

  const desktopAccountSection = () => {
    return (
      <div className='account-desktop-container account-gloabal-container mt-5 grid-container'>
        <div className='account-section-left'>
          <AccountHeaderContainer
            isMobile={isMobile}
            currentMenu={currentMenuName}
            updateMenu={data => setMenuName(data)}
            history={history}
          />
        </div>
        <div className='account-section-right account-section-right-au'>{renderSwitch(currentMenuName)}</div>
        {userOrderState.showCartClearAlert ? <ClearCartModule /> : null}
      </div>
    );
  };
  const mobileAccountSection = () => {
    return (
      <div className='mobile-order-history' id='mob-view-account-section'>
        {renderSwitch(currentMenuName)}
        {userOrderState.showCartClearAlert ? <ClearCartModule /> : null}
      </div>
    );
  };
  return isMobile ? mobileAccountSection() : desktopAccountSection();
};

export default AccountComponent;
